// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"F_PH_TheComp__bxmeU"};